import { useTranslation } from '@frontend/i18n';
import { ConfirmationModal, ModalControlModalProps } from '@frontend/design-system';

type Props = {
  message: string;
  modalProps: ModalControlModalProps;
  onCancel: () => void;
  onDelete: () => void;
  onSaveDraft: () => void;
};

export const SaveAsDraftModal = ({ message, modalProps, onCancel, onDelete, onSaveDraft }: Props) => {
  const { t } = useTranslation('messages');

  return (
    <ConfirmationModal
      {...modalProps}
      title={t('Are you sure?')}
      message={message}
      confirmLabel={t('Save As Draft')}
      cancelLabel={t('Delete')}
      backLabel={t('Cancel')}
      onConfirm={onSaveDraft}
      onCancel={onDelete}
      onBackClick={onCancel}
      secondaryDestructive={true}
    />
  );
};
